import { render, staticRenderFns } from "./TonalPost.vue?vue&type=template&id=a2f71d36&"
import script from "./TonalPost.vue?vue&type=script&lang=js&"
export * from "./TonalPost.vue?vue&type=script&lang=js&"
import style0 from "./TonalPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports